export default "__VITE_ASSET__CSV5Z789__"